var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "d-lg-flex" }, [
    _c("div", { staticClass: "filter__title d-none d-lg-flex" }, [
      _vm._v(
        "\n            " +
          _vm._s(_vm.$translate("Ceres::Template.itemFilter")) +
          "\n        "
      )
    ]),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "item-filter__wrapper d-lg-flex" },
      [
        _vm._l(_vm.facets, function(facet) {
          return _c("item-filter", {
            key: facet.id,
            ref: "itemFilter",
            refInFor: true,
            attrs: {
              facet: facet,
              "padding-classes": _vm.paddingClasses,
              "padding-inline-styles": _vm.paddingInlineStyles,
              "desktop-filter": _vm.desktopFilter
            }
          })
        }),
        _vm._v(" "),
        _c("span", { staticClass: "filter__total d-none d-lg-block" }, [
          _vm._v(
            "\n            \t" +
              _vm._s(_vm.filterTotal) +
              " " +
              _vm._s(_vm.$translate("HoferAntikschmuck::Template.objects")) +
              "\n        \t"
          )
        ])
      ],
      2
    ),
    _vm._v(" "),
    _c("div", { staticClass: "card-all d-lg-none" }, [
      _c(
        "button",
        {
          class: {
            "filter-btn--disabled":
              _vm.selectedFacets && _vm.selectedFacets.length <= 0
          },
          on: {
            click: function($event) {
              return _vm.applyFacets()
            }
          }
        },
        [
          _vm._v(
            "\n\t\t\t\t" +
              _vm._s(
                _vm.$translate("HoferAntikschmuck::Template.applyFilter")
              ) +
              "\n\t\t\t\t"
          ),
          _c("icon", { attrs: { icon: "check", loading: _vm.isLoading } })
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "span",
        {
          class: {
            "filter-btn--disabled": !_vm.isFacetActive
          },
          on: {
            click: function($event) {
              return _vm.resetAllTags()
            }
          }
        },
        [
          _vm._v(
            "\n                " +
              _vm._s(_vm.$translate("Ceres::Template.itemFilterReset")) +
              "\n                "
          ),
          _c("icon", {
            staticClass: "d-none",
            attrs: { icon: "check", loading: _vm.isLoading }
          })
        ],
        1
      )
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }